import { useContext } from "react";
import { UserLogsContext } from "../context";

export const useUserLogs = () => useContext(UserLogsContext);
